<template>
    <section class="article">
        <div class="container faq">
            <div class="row">
                <div class="col-12 head">
                    <h2 class="title">{{ $t('faq.title') }}</h2>
                </div>
            </div>
            <div class="row text-justify">
                <div class="col-12 pb-5">
                    <h5>{{ $t('faq.article_1_title') }}</h5>
                    <p>{{ $t('faq.article_1_text') }}</p>
                    <div class="accordion accordion-faq-1" id="accordion-faq-1">
                        <div class="card">
                            <div id="collapseFaq1" class="collapse" aria-labelledby="headingOne"
                                data-parent="#accordion-faq-1">
                                <div class="card-body p-0 pb-3">
                                    {{ $t('faq.article_1_read_more') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <a class="btn" type="button" data-toggle="collapse" data-target="#collapseFaq1"
                        aria-expanded="false" aria-controls="collapseThree">
                        {{ $t('sets.read_more') }}
                    </a>

                </div>
            </div>
            <div class="row text-justify">
                <div class="col-12 pb-5">
                    <h5>{{ $t('faq.article_2_title') }}</h5>
                    <p>{{ $t('faq.article_2_text') }}</p>
                    <div class="accordion accordion-faq-2" id="accordion-faq-2">
                        <div class="card">
                            <div id="collapseFaq2" class="collapse" aria-labelledby="headingOne"
                                data-parent="#accordion-faq-2">
                                <div class="card-body p-0 pb-3">{{ $t('faq.article_2_read_more') }}</div>
                            </div>
                        </div>
                    </div>
                    <a class="btn" type="button" data-toggle="collapse" data-target="#collapseFaq2"
                        aria-expanded="false" aria-controls="collapseThree">
                        {{ $t('sets.read_more') }}
                    </a>
                </div>
            </div>
            <div class="row text-justify">
                <div class="col-12 pb-5">
                    <h5>{{ $t('faq.article_3_title') }}</h5>
                    <p>{{ $t('faq.article_3_text_paragraph_1') }}</p>
                    <p>{{ $t('faq.article_3_text_paragraph_2') }}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "WhyItsWorthIt"
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Faq.vue